import { render, staticRenderFns } from "./taskLog.vue?vue&type=template&id=583e03c4&scoped=true&"
import script from "./taskLog.vue?vue&type=script&lang=tsx&"
export * from "./taskLog.vue?vue&type=script&lang=tsx&"
import style0 from "./taskLog.vue?vue&type=style&index=0&id=583e03c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583e03c4",
  null
  
)

export default component.exports